const userIsAlreadyInvited = (allUniqueEmails: string[] | null, invitationEmail:string) => {

    if(allUniqueEmails === null) return false;
    return allUniqueEmails.some((email) => email === invitationEmail);
  
}

export default userIsAlreadyInvited;